import { streamAgentTurn } from "./agentStream";
import type { WireMessage } from "./agentMemory";

const DEFAULT_TIMEOUT_MS = 60_000;

// One no-tools completion through the assistant's own stream endpoint, awaited to the full text.
// Used by the draft tool — nothing renders while it runs, so deltas are ignored.
export const streamCompletion = async (
  messages: WireMessage[],
  model: string | undefined,
  timeoutMs: number = DEFAULT_TIMEOUT_MS,
): Promise<string> => {
  const outcome = await streamAgentTurn({ messages, model }, {}, { timeoutMs });
  if (!outcome.text.trim()) {
    throw new Error("Completion delivered no text");
  }
  return outcome.text;
};
